import "../styles/main.scss";

const menuBtn = document.getElementById('kx-spf-header-menu-btn');
const menuBtnIcon = menuBtn.querySelector('i');
const headerEl = document.querySelector('.kx-spf-header');

menuBtn.addEventListener('click', function () {
    headerEl.classList.contains('kx-spf-header--show-nav') ? headerEl.classList.remove('kx-spf-header--show-nav') : headerEl.classList.add('kx-spf-header--show-nav');
    if (menuBtnIcon.classList.contains('fa-bars')) {
        menuBtnIcon.classList.remove('fa-bars');
        menuBtnIcon.classList.add('fa-xmark');
    } else {
        menuBtnIcon.classList.add('fa-bars');
        menuBtnIcon.classList.remove('fa-xmark');
    }
});

const imageFeatures = document.getElementsByClassName('kx-spf-image-feature');

for (var i = 0; i < imageFeatures.length; i++) {
    let showArrows = imageFeatures[i].getElementsByClassName('splide__slide').length > 1;
    new Splide(imageFeatures[i], {
        type: 'loop',
        arrows: showArrows,
        pagination: false,
    }).mount();
}

const threeUps = document.getElementsByClassName('kx-spf-three-up-carousel--splide');

for (var i = 0; i < threeUps.length; i++) {
    new Splide(threeUps[i], {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        pagination: false,
        arrows: true,
        breakpoint: {
            640: {
                perPage: 1
            },
        },
    }).mount();
}

const fullImgEls = document.getElementsByClassName('kx-spf-article-img-full');

for (let fullImgEl of fullImgEls) {
    fullImgEl.parentElement.style.marginBottom = '0';
}